"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Reader;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _core = require("@material-ui/core");
var _contexts = require("../../contexts");
var _styles = _interopRequireDefault(require("./styles"));
var _SideBar = _interopRequireDefault(require("../SideBar"));
var _TopBarMobile = _interopRequireDefault(require("../TopBarMobile"));
var _BottomNavigation = _interopRequireDefault(require("../BottomNavigation"));
var _Drawer = _interopRequireDefault(require("../Drawer"));
var _SearchDrawer = _interopRequireDefault(require("../SearchDrawer"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// Contexts

// Styles

// Components

function Reader(_ref) {
  var {
    children
  } = _ref;
  var classes = (0, _styles.default)();
  var {
    openDrawer
  } = (0, _react.useContext)(_contexts.SideBarContext);
  var mobileVersion = () => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_TopBarMobile.default, null), /*#__PURE__*/_react.default.createElement(_BottomNavigation.default, null), /*#__PURE__*/_react.default.createElement(_Drawer.default, null), /*#__PURE__*/_react.default.createElement(_SearchDrawer.default, null), /*#__PURE__*/_react.default.createElement("main", null, children));
  var desktopVersion = () => /*#__PURE__*/_react.default.createElement("div", {
    className: classes.drawerRoot
  }, /*#__PURE__*/_react.default.createElement(_core.CssBaseline, null), /*#__PURE__*/_react.default.createElement(_SideBar.default, null), /*#__PURE__*/_react.default.createElement(_Drawer.default, null), /*#__PURE__*/_react.default.createElement(_SearchDrawer.default, null), /*#__PURE__*/_react.default.createElement("main", {
    className: (0, _clsx.default)(classes.drawerContent, {
      [classes.contentShift]: openDrawer
    })
  }, children));
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Hidden, {
    smUp: true
  }, mobileVersion()), /*#__PURE__*/_react.default.createElement(_core.Hidden, {
    xsDown: true
  }, desktopVersion()));
}
Reader.propTypes = {
  children: _propTypes.default.node.isRequired
};